var map = {
	"./ChainBridgeAPI": 492,
	"./ChainBridgeAPI.d": 951,
	"./ChainBridgeAPI.d.ts": 951,
	"./ChainBridgeAPI.d.ts.map": 1361,
	"./ChainBridgeAPI.js": 492,
	"./ChainBridgeAPI.js.map": 1362,
	"./centrifuge-types": 952,
	"./centrifuge-types.d": 953,
	"./centrifuge-types.d.ts": 953,
	"./centrifuge-types.d.ts.map": 1363,
	"./centrifuge-types.js": 952,
	"./centrifuge-types.js.map": 1364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1360;